const PaymentMethod = {
    CARD: "card",
    CASH: "cash",
    VOUCHER: "voucher",
};

export default PaymentMethod;
